import { lazy } from 'react'

export const AchieveResultV1 = lazy(() => import('./v1/AchieveResultV1'))
export const AchieveResultV2 = lazy(() => import('./v2/AchieveResultV2'))
export const AchieveResultV3 = lazy(() => import('./v3/AchieveResultV3'))
export const AchieveResultV4 = lazy(() => import('./v4/AchieveResultV4'))
